import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Label from '../Labels/Basic'
import { MarginProps } from '../../utils/styling/StylingHelper'

type InfoLabelProps = MarginProps & {
    infoLabel: string
}

const InfoLabel: FC<InfoLabelProps> = ({ infoLabel, ...marginProps }) => (
    <Grid noExpand alignRight marginLeft="auto" {...marginProps}>
        <Label backgroundColor="ORANGE" fontColor="WHITE">
            {infoLabel}
        </Label>
    </Grid>
)

export default InfoLabel
